import React from 'react'

import classnames from 'classnames'

import { number, shape, string, oneOfType, oneOf } from 'prop-types'

const Col = ({ xs, sm, md, lg, xl, className, children }) => {
  const getSize = bp => (bp && bp.size) || bp
  const getOffset = bp => bp && bp.offset
  const getOrder = bp => bp && bp.order

  const classNameVal = classnames('cmps-col', className, {
    [`cmps-col-xs-${getSize(xs)}`]: getSize(xs),
    [`cmps-col-sm-${getSize(sm)}`]: getSize(sm),
    [`cmps-col-md-${getSize(md)}`]: getSize(md),
    [`cmps-col-lg-${getSize(lg)}`]: getSize(lg),
    [`cmps-col-xl-${getSize(xl)}`]: getSize(xl),

    [`cmps-col-offset-xs-${getOffset(xs)}`]: getOffset(xs),
    [`cmps-col-offset-sm-${getOffset(sm)}`]: getOffset(sm),
    [`cmps-col-offset-md-${getOffset(md)}`]: getOffset(md),
    [`cmps-col-offset-lg-${getOffset(lg)}`]: getOffset(lg),
    [`cmps-col-offset-xl-${getOffset(xl)}`]: getOffset(xl),

    [`cmps-col-order-${getOrder(xs)}-xs`]: getOrder(xs),
    [`cmps-col-order-${getOrder(sm)}-sm`]: getOrder(sm),
    [`cmps-col-order-${getOrder(md)}-md`]: getOrder(md),
    [`cmps-col-order-${getOrder(lg)}-lg`]: getOrder(lg),
    [`cmps-col-order-${getOrder(xl)}-xl`]: getOrder(xl),
  })

  return (
    <div className={classNameVal}>
      { children }
      <style jsx>
        {`
          @for $i from 1 to 12 {
            .cmps-col-$i {
              grid-column: span $i;
            }
          }
          @each $breakpoint, $size in (xs, sm, md, lg, xl), (0px, 576px, 768px, 992px, 1200px) {
            .cmps-col-$breakpoint {
              @for $i from 1 to 12 {
                &-$i {
                  grid-column: span 12;
                }
              }
            }
            @media screen and (min-width: $size){
              .cmps-col-$breakpoint {
                @for $i from 1 to 12 {
                  &-$i {
                    grid-column: span $i;
                    @each $bpoint in (xs, sm, md, lg, xl) {
                      @for $j from 1 to 12 {
                        &.cmps-col-offset-$(bpoint)-$j {
                          grid-column: calc($j + 1) / span $i;
                        }
                      }
                      &.cmps-col-order-first-$bpoint {
                        order: -1
                      }
                      &.cmps-col-order-last-$bpoint {
                        order: 1
                      }
                    }
                  }
                }
              }
            }
          }
        `}
      </style>
    </div>
  )
}

const posAndSize = {
  size: number,
  offset: number,
  order: oneOf(['first', 'last']),
}

const colPropTypes = oneOfType([
  shape(posAndSize),
  string, // for backward compatibility
  number,
])

Col.propTypes = {
  xs: colPropTypes,
  sm: colPropTypes,
  md: colPropTypes,
  lg: colPropTypes,
  xl: colPropTypes,
  className: string,
}

export default Col
